import React from 'react'
import Quiz from '@health-zelas/quiz'
import { SimulatorProps } from './SimulatorProps'
import theme, { reset } from '@packages/theme'

const Simulator = () => {
  reset()

  return (
    <div className={theme}>
      <script
        dangerouslySetInnerHTML={{
          __html: `
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "l5fofdyiw1");
          `
        }}
      />
      <Quiz {...SimulatorProps} />
    </div>
  )
}

export default Simulator
